module.exports = __webpack_public_path__ + "static/Anoush-b9b73d920de13aec71d5ac88eddf7e56.png";